import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Mensagem padrão (Instituto online); outra rota pode trocá-la em `data.mensagem`. */
export const MENSAGEM_INSTITUTO_INDISPONIVEL =
  'Prezado participante, o Instituto online está indisponível para o seu plano.';

export const MENSAGEM_REQUERIMENTO_INDISPONIVEL =
  'Prezado participante, o Requerimento de beneficio está indisponível para o seu plano.';

@Component({
  imports: [],
  selector: 'app-pagina-indisponivel',
  styleUrl: './pagina-indisponivel.scss',
  templateUrl: './pagina-indisponivel.html',
})
export class PaginaIndisponivel {
  /** Texto do aviso: o da rota (fluxo do requerimento) ou o padrão do Instituto online. */
  readonly mensagem: string = inject(ActivatedRoute).snapshot.data['mensagem'] ?? MENSAGEM_INSTITUTO_INDISPONIVEL;
}
